module.exports = __webpack_public_path__ + "assets/media/chat-beep.92cdcdde.mp3";